import RegistrationTracker from './RegistrationTracker';

class PersonalOrderTracker {
  private ui: {
    confirmButton: JQuery;
    basicOnlyApply: JQuery;
    basicOrCoachingApply: JQuery;
  };

  private get trackStep7SubsetMap(): any {
    return {
      tokkun: 'coaching_apply',
      credit: 'basic_credit',
      carrier: 'basic_carrier',
      webcvs: 'basic_convenience',
    };
  }

  private get trackStep7OptimizelyEventNameMap(): any {
    return {
      coaching_apply: 'coaching_payment_information_completed',
      basic_credit: 'basic_credit_payment_information_completed',
      basic_carrier: 'basic_carrier_payment_information_completed',
      basic_convenience: 'basic_convenience_payment_information_completed',
    };
  }

  private get ytmSelectorMap(): any {
    return {
      tokkun: 'ytm-new_tokkun_go_to_confirm',
      credit: 'ytm-new_basic_credit_go_to_confirm',
      webcvs: 'ytm-new_basic_convenience_go_to_confirm',
      carrier: 'ytm-new_basic_carrier_go_to_confirm',
    };
  }

  private plan: string | undefined;

  constructor() {
    this.ui = {
      confirmButton: $('#confirm'),

      // only when using template is `basic_only`
      basicOnlyApply: $('#basic-only-apply'),

      // only when using template is `basic_or_coaching`
      basicOrCoachingApply: $('.basic-or-coaching-apply'),
    };
  }

  public trackStep7(plan: string, paymentMethod: string): void {
    const subset = this.getStep7Subset(plan, paymentMethod);
    this.trackRegistrationEvent(7, subset);
    this.trackOptimizelyCustomEvent(
      this.trackStep7OptimizelyEventNameMap[subset],
    );
  }

  public replaceYtmSelector(plan: string, paymentMethod: string): void {
    const selector =
      this.ytmSelectorMap[plan] || this.ytmSelectorMap[paymentMethod];

    const classesToRemove = $.map(this.ytmSelectorMap, (_key, val) => val).join(
      ' ',
    );

    this.ui.confirmButton.removeClass(classesToRemove).addClass(selector);
  }

  public begin(): PersonalOrderTracker {
    // when only basic is applicable
    if (this.ui.basicOnlyApply.is(':visible')) {
      this.ui.basicOnlyApply.off('click.forTracking');
      this.ui.basicOnlyApply.on('click.forTracking', () => {
        this.trackRegistrationEvent(6, 'basic_only');
        this.trackOptimizelyCustomEvent('basic_only_ordered');
      });
    }

    // when both basic and coaching are applicable
    if (this.ui.basicOrCoachingApply.is(':visible')) {
      this.ui.basicOrCoachingApply.off('click.forTracking');
      this.ui.basicOrCoachingApply.on('click.forTracking', (e: any) => {
        this.plan = $(e.currentTarget).data('plan');

        if (this.plan === 'basic') {
          this.trackRegistrationEvent(6, 'basic_choice');
          this.trackOptimizelyCustomEvent('basic_choice_ordered');
        } else if (this.plan === 'tokkun') {
          this.trackRegistrationEvent(6, 'coaching_choice');
          this.trackOptimizelyCustomEvent('coaching_choice_ordered');
        }
      });
    }

    return this;
  }

  private trackRegistrationEvent(step: number, subset?: string): void {
    const tracker = new RegistrationTracker();
    tracker.track(step, { subset });
  }

  // Event design
  // https://docs.google.com/spreadsheets/d/1jj9km7Iu0yv2dTLWnUWoaeW6ymU-OTHM8qL8QqTsK40/edit
  private trackOptimizelyCustomEvent(eventName: string): void {
    (window as any).optimizely = (window as any).optimizely || [];
    (window as any).optimizely.push(['trackEvent', eventName]);
  }

  private getStep7Subset(plan: string, paymentMethod: string): string {
    // If template is `basic_or_coaching`
    // `@plan` will be set on moving choose_plan page to order_detail page.
    const subset = this.trackStep7SubsetMap[this.plan || plan];
    return subset || this.trackStep7SubsetMap[paymentMethod];
  }
}

export default PersonalOrderTracker;
